import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges,} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {DtoList} from "../../../../core/shared/dto/dto.list";
import {MvsCoreService} from "../../../../core/shared/service/mvs-core.service";
import {UmUserService} from "../../service/api/um-user.service";
import {MvsMessageService} from "../../../../core/shared/service/message/mvs-message.service";
import {FieldStorageService} from "../../../../core/shared/form/field/service/field-storage.service";
import {DtoDetail} from "../../../../core/shared/dto/dto.detail";
import {ObjectIdentifier} from "../../../../core/shared/basic/object-identifier";
import {UiCommentEvent} from "../../../../core/shared/components/mvs-quill-editor/data/ui-comment-event";
import {UploadDocumentEventInterface} from "../../../../core/shared/dto/upload-document-event.interface";

//TODO: This whole implementation is bad. euVisible does not belong to this component!
@Component({
    selector: 'mvs-comments',
    templateUrl: './comments.component.html',
    standalone: false
})
export class CommentsComponent implements OnInit, OnChanges, OnDestroy {

    @Input() objectIdentifier: ObjectIdentifier;
    @Input() documentTypeId: number;
    @Input() serviceInterface: MvsCrudService;
    @Input() referenceId: number;
    @Input() hideLabel: boolean;
    @Input() euVisible: boolean = false;
    @Output() onComment = new EventEmitter<DtoDetail>();
    @Output() onInputChange = new EventEmitter<string>();
    @Output() onUploadDocument = new EventEmitter<UploadDocumentEventInterface>();
    userNamesList: DtoList[];
    mentionUsers: { id: number; value: string }[];
    newComment: string;
    recoveredText: string;
    localStorageKey: string;
    content: string;
    focused: boolean;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    constructor(
        protected coreService: MvsCoreService,
        protected userService: UmUserService,
        protected messageService: MvsMessageService,
        protected fieldStorageService: FieldStorageService) {
    }

    ngOnInit(): void {
        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {

        // retrieve list of all active users (required for the mentions within the comments)
        this.userService.getAllActiveUsers().subscribe(value => {
            let dtoListUsers: any = value;
            this.userNamesList = dtoListUsers.entries.map(
                (element: any) => element.name
            );
            this.mentionUsers = dtoListUsers.entries.map(
                (element: any) => ({ id: element.id, value: element.name })
            );
        });
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        // this.retrieveUnsavedData();
        this.initialized = true;
    }

    /**
     * create comment
     */
    createComment(event: UiCommentEvent) {
        if (!event.comment || event.comment.trim().length === 0) {
            return;
        }

        this.busy = true;
        this.newComment = event.comment;
        const dtoDetail = new DtoDetail();

        dtoDetail["ticketDtoId"] = this.referenceId;
        dtoDetail["entityStatus"] = 3;
        dtoDetail["comment"] = this.newComment;
        dtoDetail['euVisible'] = event.euVisible;

        this.serviceInterface.create(dtoDetail).subscribe(value => {

            this.newComment = "";
            this.clearLocalStorage();
            // refresh Ticket comments
            this.onComment.emit(value);

            this.busy = false;
            this.messageService.showSuccessMessage("Ticket", "Comment created");
        }, error => {

            this.busy = false;
            this.messageService.showErrorMessage("Ticket", "Error occured");
        })


    }

    handleInputChange(comment: string) {
        this.newComment = comment;
        this.handleStoreLocalStorage();
        this.onInputChange.emit(this.newComment);
    }

    handleDocumentUpload(event: UploadDocumentEventInterface) {
        this.onUploadDocument.emit(event);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    handleStoreLocalStorage() {
        this.localStorageKey = this.fieldStorageService.generateKey('tm.TicketComment', 0, 'comment');
        this.fieldStorageService.saveToLocalStorage(this.localStorageKey, this.newComment);
    }

    loadRecoveredValue() {
        this.content = this.recoveredText;
    }

    clearLocalStorage() {
        this.fieldStorageService.clearFieldData(this.localStorageKey);
        this.recoveredText = null;
    }


    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

}
